import { getNavListData } from '@/api/config.js'

const state = {
  // navList: [
  //   { id: 120, title: '社区简介', path: '/communityIntro' },
  //   { id: 121, title: '党务公开', path: '/publicityParty' },
  //   { id: 122, title: '居务公开', path: '/publicityHousing' },
  //   { id: 123, title: '新时代文明建设', path: '/civilizationConstr' },
  //   { id: 124, title: '森林防灭火', path: '/fireFighting' },
  //   { id: 125, title: '退役军人服务', path: '/veteransService' },
  //   { id: 126, title: '疫情防控', path: '/epidemicControl' },
  //   { id: 128, title: '专题活动', path: '/thematicActi' },
  //   { id: 129, title: '便民服务', path: '/convenienceService' }
  // ],
  navListData: [],
  currentPageTitle: '',
  currentPageTitleId: '',
  dialogIsShow: false,
  dialogCommonIsShow: false,
  currentModalName: '', // 当前二级弹框模块名称
  currentModuleId: 0,
  screenSize: 1,
  filePreviewShow: false,
  currentFilename: '',
  /* theme */
  themeObj: {},
  canIuse: true,
  toPath: ''
}

const getters = {
  getNavList(state) {
    return state.navListData
  },
  getCurrentPageTitle(state) {
    return state.currentPageTitle
  },
  getCurrentPageTitleId(state) {
    return state.currentPageTitleId
  },
  getDialogIsShow(state) {
    return state.dialogIsShow
  },
  getDialogCommonIsShow(state) {
    return state.dialogCommonIsShow
  },
  getCurrentModalName(state) {
    return state.currentModalName
  },
  getCurrentModuleId(state) {
    return state.currentModuleId
  },
  getScreenSize(state) {
    return state.screenSize
  },
  getFilePreviewShow(state) {
    return state.filePreviewShow
  },
  getCurrentFilename(state) {
    return state.currentFilename
  },
  getCurrentNavObj(state) {
    if (state.navListData.length > 0) {
      // const currentNavObj = state.navListData.filter(item => item.templateName === state.currentPageTitle)[0]
      const currentNavObj = state.navListData.filter(item => item.id === state.currentPageTitleId)[0]
      return currentNavObj
    }
  },
  getThemeObj(state) {
    return state.themeObj
  },
  getCanIuse(state) {
    return state.canIuse
  },
  getToPath(state) {
    return state.toPath
  }
}

const mutations = {
  SET_NAVLIST_ORIGIN: (state, navList) => { // temporarily useless
    state.navList = navList
  },
  SET_NAVLIST: (state, navListData) => {
    state.navListData = navListData
  },
  SET_CURRENT_TITLE: (state, title) => {
    state.currentPageTitle = title
  },
  SET_CURRENT_TITLE_ID: (state, id) => {
    state.currentPageTitleId = id
  },
  SET_CURRENT_MODALNAME: (state, title) => {
    state.currentModalName = title
  },
  SET_CURRENT_MODULE_ID: (state, id) => {
    state.currentModuleId = id
  },
  SET_DIALOG: (state, Bool) => {
    state.dialogIsShow = Bool
  },
  SET_DIALOG_COMMON: (state, Bool) => {
    state.dialogCommonIsShow = Bool
  },
  SET_SCREEN_SIZE: (state, size) => {
    state.screenSize = size
  },
  SET_FILE_PREVIEW: (state, Bool) => {
    state.filePreviewShow = Bool
  },
  SET_CURRENT_FILENAME: (state, filename) => {
    state.currentFilename = filename
  },
  SET_THEME_OBJ: (state, theme) => {
    state.themeObj = theme
  },
  SET_CAN_I_USE: (state, bool) => {
    state.canIuse = bool
  },
  SET_toPath: (state, path) => {
    state.toPath = path
  }
}

const actions = {
  getNavListReq({ commit, state }, { businessId = 0 }) {
    return new Promise((resolve, reject) => {
      const params = {
        userid: localStorage.getItem('screenUserid') || 0,
        village: localStorage.getItem('currentCommunity') || ''
      }
      if (!params?.village) return

      getNavListData(params).then(res => {
        const { msg, msg2, img } = res
        sessionStorage.setItem('livingBg', img)
        if (res.code == 0) {
          commit('SET_CAN_I_USE', true)

          commit('SET_NAVLIST', msg)

          let current_businessId = businessId || msg[0].id
          // console.log('current_businessId', current_businessId)
          msg && msg.length > 0 && msg.forEach(item => {
            if (current_businessId == item.id) {
              commit('SET_CURRENT_TITLE', item.templateName)
              commit('SET_CURRENT_TITLE_ID', item.id)
            }
          })

          commit('SET_THEME_OBJ', msg2)

          resolve(msg)
        } else {
          commit('SET_CAN_I_USE', false)
          resolve('err')
        }
        // resolve(msg)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
